<header *ngIf="!appStateService.isPlayerMode() || isAdminReviewPage()" class="lg:py-8 py-3 sticky top-0 z-50 backdrop-blur-md bg-white dark:bg-zinc-900 border-b border-zinc-200 dark:border-zinc-800">
    <div class="relative container flex flex-wrap items-center">
        <div class="flex gap-3 items-center">
            <!-- Mobile Menu Toggle Button -->
        <p-button type="button" (onClick)="toggleMobileMenu()" id="mobile-menu-toggle"
            text="true" severity="contrast" class="sm:hidden"
            [attr.aria-label]="mobileMenuOpen() ? 'Close navigation menu' : 'Open navigation menu'"
            [attr.aria-expanded]="mobileMenuOpen()">
            <i [class]="mobileMenuOpen() ? 'ti ti-x text-3xl' : 'ti ti-menu-2 text-3xl'"
                class="text-zinc-600 dark:text-zinc-300"></i>
        </p-button>

        <!-- Logo -->
        <a [routerLink]="['/learner']" class="flex-shrink-0 hover:opacity-80 transition-opacity" [ngClass]="{'border-4': userwaySettings.value.highlightLinks}">
            <img [src]="logoSrc" class="h-10 lg:h-12" alt="Youth4Jobs Logo">
        </a>
        </div>

        <!-- Desktop Navigation -->
        <nav class="hidden sm:flex ml-auto items-center gap-4" aria-label="Main navigation">
            <div class="flex items-center gap-1">
                <a [routerLink]="['/learner']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    #rla="routerLinkActive"
                    [class]="'px-3 py-2 text-sm rounded-lg transition-all duration-200 font-medium ' +
                        (rla.isActive ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-b-2 border-blue-600 dark:border-blue-400' : 'text-zinc-700 dark:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800 border-b-2 border-transparent')">
                    Home
                </a>

            </div>

            <span class="h-6 w-px bg-zinc-300 dark:bg-zinc-600" aria-hidden="true"></span>


            <!-- Theme Toggle -->
          <button type="button" (click)="isDarkMode = !isDarkMode; onThemeToggle()"
                    [class]="'relative inline-flex h-8 w-12 items-center rounded-full transition ' + (isDarkMode ? 'bg-zinc-800' : 'bg-zinc-300')" 
                    [ngClass]="{'border border-white': userwaySettings.isDarkContrast(), 'border border-black': userwaySettings.isLightContrast()}"
                    [attr.aria-label]="'Toggle dark mode.Currently in ' + (isDarkMode ? 'dark mode' : 'light mode')">
                    <!-- Knob -->
                    <span [class]="'absolute left-1 top-1 flex h-6 w-6 items-center justify-center border-zinc-500 rounded-full bg-white shadow transition ' +
                        (isDarkMode ? 'translate-x-4' : 'translate-x-0')"
                        [ngClass]="{'border border-white': userwaySettings.isDarkContrast(), 'border border-black': userwaySettings.isLightContrast()}">
                        <i class="ti" [ngClass]="isDarkMode ? 'ti-moon text-zinc-800' : 'ti-sun text-yellow-500'"></i>
                    </span>
           </button>

            <!-- Language Selector -->
            <!-- <p-iconfield>
                <p-inputicon styleClass="ti ti-world z-2 !text-lg" aria-hidden="true" />
                <p-select styleClass="pl-10 !bg-inherit !border-none !shadow-none !h-10 !leading-none !flex !items-center !justify-center"
                    panelStyleClass="!z-[9999]" size="small" [options]="languages"
                    [(ngModel)]="selectedLanguage" optionLabel="name"
                    placeholder="Language" aria-label="Select language">
                </p-select>
            </p-iconfield> -->

            <span class="h-6 w-px bg-zinc-300 dark:bg-zinc-600" aria-hidden="true"></span>

            <!-- Notifications Bell -->
            <div class="relative">
                <button type="button" id="notifications-icon" (click)="toggleNotifications()"
                    text="true" class="rounded-lg p-4 !leading-none hover:bg-zinc-300"
                    [attr.aria-label]="'Notifications, ' + notificationsUnreadCount() + ' unread'">
                    <p-overlaybadge [style]="isDarkMode ? {'background-color': '#F87171'} : {'background-color': '#B91C1C'}" severity="danger" *ngIf="notificationsUnreadCount()" [value]="notificationsUnreadCount()"
                        [styleClass]="'!leading-none !flex !items-center !justify-center ' + ((userwaySettings.isDarkContrast() && isDarkMode) ? 'border border-white' : (userwaySettings.isLightContrast() && !isDarkMode) ? 'border border-black' : '')">
                        <i class="ti ti-bell text-2xl text-zinc-600 dark:text-zinc-400"></i>
                    </p-overlaybadge>
                    <i class="ti ti-bell text-2xl text-zinc-600 dark:text-zinc-400 " *ngIf="!notificationsUnreadCount()" ></i>
                </button>
                <app-notifications-menu *ngIf="showNotificationsMenu()" [showNotifications]="showNotificationsMenu()" (closeNotifications)="this.showNotificationsMenu.set(false)"></app-notifications-menu>
            </div>
            

            <!-- Profile Initials Avatar -->
             <div class="relative">
                <button class="flex-col items-center gap-1.5 cursor-pointer p-1 rounded-lg"
                    aria-label="Profile menu"
                    (click)="toggleMenu()"  #profileBtn>
                    <div class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 hover:from-blue-700 hover:to-blue-800 flex items-center justify-center text-white font-bold text-sm"
                        aria-label="User initials">
                        {{ userInitials() }}
                    </div>
                    <!-- <i class="ti ti-chevron-down text-zinc-600 dark:text-zinc-300 text-sm" aria-hidden="true"></i> -->
                </button>
                <div *ngIf="showProfileMenu()">
                    <ng-container *ngTemplateOutlet="profileMenu" ></ng-container>
                </div>
                </div>
        </nav>

        <!-- Mobile Navigation Menu -->
        <nav *ngIf="mobileMenuOpen()"
            class="h-[calc(100vh-3.5rem)] sm:hidden absolute top-[3.5rem] left-0 right-0 bg-white dark:bg-zinc-900 border-b border-zinc-200 dark:border-zinc-800 py-4 px-4 w-full overflow-y-auto"
            aria-label="Mobile navigation">
            <div class="space-y-2">
                <a [routerLink]="['/learner']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    #rla="routerLinkActive"
                    (click)="toggleMobileMenu()"
                    [class]="'w-full flex items-center gap-3 px-3 py-3 text-left rounded-lg transition-all duration-200 font-medium ' +
                        (rla.isActive ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-l-4 border-blue-600 dark:border-blue-400' : '') + ' ' +
                        ('text-zinc-700 dark:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800')">
                    <i [class]="'ti ti-home text-lg ' +
                        (rla.isActive ? 'text-blue-600 dark:text-blue-400' : 'text-zinc-400 dark:text-zinc-500')"
                        aria-hidden="true"></i>
                    <span [class]="rla.isActive ? 'font-semibold' : ''">Home</span>
                </a>


                <div class="border-t border-zinc-200 dark:border-zinc-700 my-3 pt-3">
                    <!-- Mobile Theme Toggle -->
                    <div class="px-4 py-2 flex items-center justify-between">
                        <span class="text-sm font-medium text-zinc-700 dark:text-zinc-200">Dark Mode</span>
                        <button type="button" (click)="isDarkMode = !isDarkMode; onThemeToggle()"
                            [class]="'relative inline-flex h-6 w-11 items-center rounded-full transition ' +
                            (isDarkMode ? 'bg-blue-600' : 'bg-zinc-300')"
                            [ngClass]="{'border border-white': userwaySettings.isDarkContrast(), 'border border-black': userwaySettings.isLightContrast()}"
                            [attr.aria-label]="'Toggle dark mode. Currently in ' + (isDarkMode ? 'dark mode' : 'light mode')">
                            <span [class]="
                                'absolute flex h-5 w-5 items-center justify-center rounded-full bg-white shadow transition ' +
                                (isDarkMode ? 'translate-x-5' : 'translate-x-0.5')"
                                [ngClass]="{'border border-white': userwaySettings.isDarkContrast(), 'border border-black': userwaySettings.isLightContrast()}">
                                <i class="ti text-xs" [ngClass]="isDarkMode ? 'ti-moon text-blue-600' : 'ti-sun text-yellow-500'"></i>
                            </span>
                        </button>
                    </div>

                    <!-- Mobile Language Selector -->
                    <div class="px-4 py-2 flex items-center justify-between gap-3">
                        <label for="language" class="text-sm font-medium text-zinc-700 dark:text-zinc-200 whitespace-nowrap">Language</label>
                        <p-iconfield >
                            <p-inputicon styleClass="ti ti-world z-2 !text-lg" aria-hidden="true" />
                            <p-select id="language" styleClass="pl-10 !bg-zinc-100 dark:!bg-zinc-800 !border-zinc-300 dark:!border-zinc-600 w-full"
                                [showClear]="false" size="small" [options]="languages"
                                [(ngModel)]="selectedLanguage" optionLabel="name"
                                placeholder="Language" aria-label="Select language">
                            </p-select>
                        </p-iconfield>
                    </div>
                </div>

                <div class="relative border-t border-zinc-200 dark:border-zinc-700 my-3 pt-3 space-y-2">
                    <!-- Mobile Notifications -->
                    <button type="button" (click)="toggleNotifications(); toggleMobileMenu()"
                        class="w-full text-left px-4 py-2.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors flex items-center gap-3"
                        [attr.aria-label]="'Notifications, ' + notificationsUnreadCount() + ' unread'">
                        <i class="ti ti-bell text-xl text-zinc-600 dark:text-zinc-400"></i>
                        <div class="flex items-center gap-2">
                            <span class="text-zinc-700 dark:text-zinc-200 font-medium">Notifications</span>
                            <span *ngIf="notificationsUnreadCount() > 0"
                                class="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                                {{ notificationsUnreadCount() }}
                            </span>
                        </div>
                        <app-notifications-menu *ngIf="showNotificationsMenu()" [showNotifications]="showNotificationsMenu()" (closeNotifications)="closeNotifications()"></app-notifications-menu>
                    </button>

                    <!-- Mobile Profile Link -->
                    <a [routerLink]="navigateToProfileRoute()"
                        (click)="toggleMobileMenu()"
                        class="flex items-center gap-3 px-4 py-2.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors">
                        <div class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-bold text-xs"
                            aria-label="User initials">
                            {{ userInitials() }}
                        </div>
                        <span class="text-zinc-700 dark:text-zinc-200 font-medium">Profile</span>
                        <div *ngIf="showProfileMenu()">
                            <ng-container *ngTemplateOutlet="profileMenu" ></ng-container>
                        </div>
                    </a>

                    <!-- Mobile Logout Button -->
                    <button type="button" (click)="logout(); toggleMobileMenu()"
                        class="w-full text-left px-4 py-2.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-950 hover:text-red-600 dark:hover:text-red-400 transition-colors flex items-center gap-3">
                        <i class="ti ti-logout text-lg text-zinc-600 dark:text-zinc-400"></i>
                        <span class="text-zinc-700 dark:text-zinc-200 font-medium">Logout</span>
                    </button>
                </div>
            </div>
        </nav>

    </div>
</header>
<ng-template #profileMenu>
    <div
        class="absolute right-0 m-2 !w-[150px] rounded-lg border border-zinc-300
                p-2 w-fit bg-white dark:bg-black shadow-lg z-[9999]">

        <button 
        *ngFor="let item of items"
        (click)="item.command()" (keydown.enter)="item.command()"
        class="flex items-center !w-full gap-2 p-2 w-full text-left rounded-md
                hover:bg-zinc-100 dark:hover:bg-zinc-800
                 mb-1 last:mb-0">

        <i [class]="item.icon"></i>
        {{ item.label }}
        </button>
    </div>
</ng-template>